import { LEVEL_LABELS } from "@/constants";

const ROWS = [
  { level: 1, b10: "2.5" },
  { level: 2, b10: "5.0" },
  { level: 3, b10: "7.5" },
  { level: 4, b10: "10.0" },
];

export const EquivalenceTable = ({ compact = false }) => (
  <div className={compact ? "" : "sketch-border-soft bg-[var(--cream-soft)] p-4"} data-testid="equivalence-table">
    <div className="text-xs uppercase tracking-wider text-[var(--ink-soft)] mb-2">
      Tabla de equivalencias · captura interna 1–4 → calificación base 10 (×2.5)
    </div>
    <table className="text-sm w-full max-w-md">
      <thead>
        <tr className="text-left text-xs text-[var(--ink-soft)] border-b border-[var(--line)]">
          <th className="py-1 pr-4">Nivel capturado</th>
          <th className="py-1 pr-4">Significado</th>
          <th className="py-1">Se muestra como</th>
        </tr>
      </thead>
      <tbody>
        {ROWS.map((r) => (
          <tr key={r.level} className="border-b border-[var(--line)]/50" data-testid={`equiv-row-${r.level}`}>
            <td className="py-1.5 pr-4 font-display text-lg text-[var(--lala-blue)]">{r.level}</td>
            <td className="py-1.5 pr-4">{LEVEL_LABELS[r.level]}</td>
            <td className="py-1.5 font-bold">{r.b10} / 10</td>
          </tr>
        ))}
      </tbody>
    </table>
    <div className="mt-3 pt-2 border-t border-[var(--line)]" data-testid="classification-ranges">
      <div className="text-xs uppercase tracking-wider text-[var(--ink-soft)] mb-1.5">
        Clasificación por score total (base 10)
      </div>
      <div className="flex flex-wrap gap-1.5 text-xs">
        {[
          ["Recuperación", "< 5.8", "#E0162B"],
          ["Bronce", "5.8 – 7.4", "#B87333"],
          ["Plata", "7.5 – 8.4", "#94A3B8"],
          ["Oro", "8.5 – 9.4", "#D4A437"],
          ["Platino", "9.5 – 10", "#0033AD"],
        ].map(([lbl, rng, color]) => (
          <span key={lbl} className="px-2 py-1 rounded-full font-semibold text-white" style={{ background: color }}
            data-testid={`class-range-${lbl.toLowerCase()}`}>
            {lbl} · {rng}
          </span>
        ))}
      </div>
      <p className="text-[11px] text-[var(--ink-soft)] mt-1.5">
        El máximo posible es <strong>10 / 10</strong> — un proveedor con score de 9.5 a 10 alcanza <strong>Platino</strong>.
      </p>
    </div>
  </div>
);
